import React from 'react';
import VerticalNav from 'components/v2/navs/VerticalNav';
import UserCircleIcon from 'components/v2/icons/UserCircleIcon';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const Sidebar = ({ userId, activePage }) => {
    function isActive(page) {
        return activePage === page;
    }
    const { t } = useTranslation();
    const profileActive = isActive('profile');
    return (React.createElement(VerticalNav, null,
        React.createElement(VerticalNav.NavItemWithIcon, { url: `/users/${userId}`, active: profileActive, title: titleize(t('PROFILE', { count: 1 })) }, (iconClassName) => (React.createElement(UserCircleIcon, { size: "medium", className: iconClassName })))));
};
Sidebar.propTypes = {
    userId: PropTypes.string,
    activePage: PropTypes.string,
};
Sidebar.defaultProps = {
    activePage: 'profile',
};
export default Sidebar;
